import React, { useEffect, useState } from "react";
import { Box, Text, Spinner, Flex, Badge, VStack } from "@chakra-ui/react";
import { FaExclamationTriangle } from "react-icons/fa";
import axios from "axios";

const API = process.env.REACT_APP_API_URL;

const WhatsNew = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchChanges();
  }, []);

  const fetchChanges = async () => {
    try {
      const res = await axios.post(`${API}/validation/data-quality-changes`, {});
      setData(res.data?.data || null);
    } catch (err) {
      console.error("Failed to fetch data quality changes", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Flex justify="center" p={4}><Spinner size="md" /></Flex>;
  if (!data) return <Text fontSize="sm" color="gray.500">Unable to load change data.</Text>;

  const { new_duplicates = [], new_inconsistent = [], new_missing = [], total_new = 0, snapshot_date } = data;

  if (total_new === 0) {
    return (
      <Box textAlign="center" py={6}>
        <Text fontSize="sm" color="green.500" fontWeight="600">No new issues since last check</Text>
        {snapshot_date && <Text fontSize="xs" color="gray.400" mt={1}>Last snapshot: {new Date(snapshot_date).toLocaleString()}</Text>}
      </Box>
    );
  }

  return (
    <Box>
      {snapshot_date && <Text fontSize="xs" color="gray.400" mb={3}>Compared to snapshot from {new Date(snapshot_date).toLocaleString()}</Text>}
      <VStack align="stretch" spacing={2}>
        {new_duplicates.map((d, i) => (
          <Flex key={`d-${i}`} align="center" gap={2} bg="red.50" px={3} py={2} borderRadius="md">
            <FaExclamationTriangle color="#E53E3E" size={12} />
            <Badge colorScheme="red" fontSize="2xs">NEW</Badge>
            <Text fontSize="xs">
              <strong>Duplicate Store:</strong> {d.site_code}/{d.retailer} — {d.descriptions?.join(", ")}
            </Text>
          </Flex>
        ))}
        {new_inconsistent.map((d, i) => (
          <Flex key={`i-${i}`} align="center" gap={2} bg="orange.50" px={3} py={2} borderRadius="md">
            <FaExclamationTriangle color="#DD6B20" size={12} />
            <Badge colorScheme="orange" fontSize="2xs">NEW</Badge>
            <Text fontSize="xs">
              <strong>Inconsistent Description:</strong> {d.std_site_code}/{d.retailer} — {d.descriptions?.join(" vs ")}
            </Text>
          </Flex>
        ))}
        {new_missing.map((d, i) => (
          <Flex key={`m-${i}`} align="center" gap={2} bg="yellow.50" px={3} py={2} borderRadius="md">
            <FaExclamationTriangle color="#D69E2E" size={12} />
            <Badge colorScheme="yellow" fontSize="2xs">NEW</Badge>
            <Text fontSize="xs">
              <strong>Missing Store:</strong> {d.site_code}/{d.retailer} — {d.site_description}
            </Text>
          </Flex>
        ))}
      </VStack>
    </Box>
  );
};

export default WhatsNew;
